import styled from '@emotion/styled';
import { ContentBodyPadding, isPC, MaxContentBodySize } from 'constants/layout';

export const ContentBodyContainer = styled.div`
  padding: 0 ${ContentBodyPadding}px;
`;

export const ContentBodyPaddingContainer2 = styled.div`
  width: 100%;

  margin: 0 auto;
  padding: 0 ${ContentBodyPadding}px;

  @media (${isPC}) {
    max-width: ${MaxContentBodySize}px;
  }
`;

export const ContentBodyPaddingContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  gap: 16px;

  margin: 0 auto;
  padding: 0 ${ContentBodyPadding}px;

  @media (${isPC}) {
    max-width: ${MaxContentBodySize}px;
  }
`;

export const ContentBodyNoPaddingContainer = styled.div`
  height: 100%;
  width: 100%;

  margin: 0 auto;
  padding: 0;

  @media (${isPC}) {
    max-width: ${MaxContentBodySize}px;
  }
`;
